import { Message } from './Message';
import * as Styled from './MessagesList.styled';

import React from 'react';
import { IInboxMessagePreviewWithTags } from 'shared/src/courier/organizationTagUtils';

type Props = Readonly<{
  messages: IInboxMessagePreviewWithTags[];
  markMessageArchived: (messageId: string, fromWS?: boolean) => Promise<void>;
}>;

export const MessagesList: React.FC<Props> = ({ messages, markMessageArchived }) => {
  if (!messages.length) {
    return (
      <Styled.EmptyList>
        <Styled.EmptyBell />

        <div>No messages</div>
      </Styled.EmptyList>
    );
  }

  return (
    <div data-testid='messages-list'>
      {messages.map((it) => (
        <Message
          key={it.messageId}
          message={it}
          markMessageArchived={markMessageArchived}
        />
      ))}
    </div>
  );
};
